import { atomWithStorage } from 'jotai/utils';

// UNCARVED DOMAIN KEY (app-shell, ARCFE-1029): per-device Ambient Heidi opt-in.
// localStorage preference, not a query cache identity. App-shell has no package.
// eslint-disable-next-line @heidi/rules/no-new-cache-key-declaration -- UNCARVED DOMAIN KEY (app-shell, ARCFE-1029): per-device Ambient Heidi opt-in; localStorage preference, not a query cache identity
export const AMBIENT_HEIDI_ENABLED_STORAGE_KEY = 'heidi:ambient-heidi-enabled';

export const ambientHeidiEnabledAtom = atomWithStorage(
  AMBIENT_HEIDI_ENABLED_STORAGE_KEY,
  false,
  undefined,
  { getOnInit: true }
);

ambientHeidiEnabledAtom.debugLabel = 'ambientHeidiEnabledAtom';
